import React from 'react';
import PropTypes from 'prop-types';

const DataGrid = props => (
  <section className="dtp-datagrid">
    <h3 className="dtp-datagrid-header">{props.title}</h3>
    <div className="dtp-datagrid-data">
      <div className="dtp-datagrid-icon-box">
        <i className={`dtp-datagrid-icon ${props.icon}`} />
      </div>
      <div className="dtp-datagrid-items-box" >
        {props.children}
      </div>
    </div>
  </section>
);

DataGrid.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  children: PropTypes.element,
}.isRequired;

export default DataGrid;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/DataGrid.jsx